import { AppContext } from '../../../../context';
import { EventTemplate, ExternalEvent } from '../../../../types';
import { useContext } from 'react';

import './ListInterviews.scss';

const getTotalHours = (events: EventTemplate[] | []) => {
    let result = 0;
    for (const event of events) {
        result += event.duration;
    }
    return result;
};

function toHoursAndMinutes(totalMinutes: number) {
    if (!totalMinutes) return { hours: 0, minutes: 0 };
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return { hours, minutes };
}

const pillHoursLabel = (
    { hours = 0, minutes = 0 },
    translate: (val: string, dynamicValueObject?: Record<string, unknown>) => string,
) => {
    let hoursAndMins = '';

    if (hours) {
        hoursAndMins = translate('general:hoursLetter', { count: hours });
    }

    if (minutes) {
        if (hoursAndMins) {
            hoursAndMins += ' ';
        }
        hoursAndMins += translate('general:minutesLetter', { count: minutes });
    }

    return hoursAndMins;
};

const ListInterviews = ({
    events = [],
    greetEvent = null,
    walkoutEvent = null,
}: {
    events?: EventTemplate[];
    greetEvent?: ExternalEvent | null;
    walkoutEvent?: ExternalEvent | null;
}) => {
    const { meetIntro, getValueForBrandStringField, translate } = useContext(AppContext);
    if (!events.length) return null;

    const totalTime = toHoursAndMinutes(getTotalHours(events));
    const canDisplayTopic = events.every((e) => e.topic);
    const defaultTopic = 'Part';
    const totalTimeFormatted = pillHoursLabel(totalTime, translate);
    return (
        <>
            <div className="flexCardBodyRightHeader">
                <span className="flexCardBodyRightTitle">
                    {getValueForBrandStringField(meetIntro?.data?.meetIntroScheduleHeader, 'intro:yourInterviews') ||
                        translate('intro:yourInterviews')}
                </span>
                <span className="flexCardBodyRightDescription">
                    {translate('intro:hoursTotalTime', { count: totalTimeFormatted })}
                </span>
            </div>
            <div className="flexCardBodyRightEvents">
                <ul className="flexCardBodyRightEventsList">
                    {greetEvent && greetEvent?.settings?.includeInExternalEvent && (
                        <li key={`${greetEvent.id}`}>
                            <span className="flexCardBodyRightEventsPill">
                                {pillHoursLabel(toHoursAndMinutes(greetEvent.durationMin), translate)}
                            </span>
                            <span className="flexCardBodyRightEventsDescription">{greetEvent.title}</span>
                        </li>
                    )}

                    {events.map(({ duration, title, topic }, i) => (
                        <li key={`${duration}-${title}`}>
                            <span className="flexCardBodyRightEventsPill">
                                {pillHoursLabel(toHoursAndMinutes(duration), translate)}
                            </span>
                            <span className="flexCardBodyRightEventsDescription">
                                {canDisplayTopic ? topic : `${defaultTopic} ${i + 1}`}
                            </span>
                        </li>
                    ))}

                    {walkoutEvent && walkoutEvent?.settings?.includeInExternalEvent && (
                        <li key={`${walkoutEvent.id}`}>
                            <span className="flexCardBodyRightEventsPill">
                                {pillHoursLabel(toHoursAndMinutes(walkoutEvent.durationMin), translate)}
                            </span>
                            <span className="flexCardBodyRightEventsDescription">{walkoutEvent.title}</span>
                        </li>
                    )}
                </ul>
            </div>
        </>
    );
};

export default ListInterviews;
